/** Package constants organized in a plain object. */
export const Constants = {
  FirebaseAuthNotInitialized: 'Firebase Auth not initialized', // Error message for uninitialized Firebase auth.
  NoUserSignedIn: 'No user signed in' // Error message thrown when an auth operation requires a signed-in user but none is present.
} as const;
